module Meevo.Plugins.ProfileSettings {
    "use strict";

    /**
    * Services Section of ImageGallerySection 
    */
    export class ImageGallerySection extends Meevo.Plugins.Employee.ImageGallerySection {


    }
}